export default __webpack_public_path__ + "static/5gff-thumbnail-0e2e72db54b2a85cde589694d087522a.jpg";